/** THIS IS AN AUTO GENERATED FILE, DO NOT EDIT MANUALLY -- Created by @graphql-codegen */
import * as Types from '../../../shared/generated.types'

import { api } from '../../../utils'
export const TimeSlotExternalFrag = `
    fragment TimeSlotExternalFrag on TimeSlot {
  id
  scheduleId
  startDate
  endDate
  startTime
  endTime
  dayOfWeek
  durationMinutes
  serviceCategoryCode
  locations
  provider {
    id
    name
    serviceType
    availabilityStatus
    availabilityNotes
    insurancePlans
    careCoordinatorId
    supervisorId
    genderIdentity
    race
    ethnicity
    languages
    spirituality
    communityIdentity
    clinicalAges
    clinicalModalities
    clinicalSpecialties
    bio
    legalSex
    profession
    licenses {
      licenseType
      stateCode
    }
  }
}
    `
export const TimeSlotSearchExternalResFrag = `
    fragment TimeSlotSearchExternalResFrag on TimeSlotSearchRes {
  results {
    ...TimeSlotExternalFrag
  }
  resultCount
  from
  searchAfter
  aggregations
}
    `
export const TimeSlotSearchExternalDocument = `
    query timeSlotSearchExternal($query: AWSJSON!, $aggregations: AWSJSON, $sort: AWSJSON, $pageSize: Int, $from: Int, $searchAfter: AWSJSON) {
  timeSlotSearch(
    query: $query
    aggregations: $aggregations
    sort: $sort
    pageSize: $pageSize
    from: $from
    searchAfter: $searchAfter
  ) {
    ...TimeSlotSearchExternalResFrag
  }
}
    ${TimeSlotSearchExternalResFrag}
${TimeSlotExternalFrag}`

const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    timeSlotSearchExternal: build.query<
      Types.TimeSlotSearchExternal,
      Types.TimeSlotSearchExternalVariables
    >({
      query: (variables) => ({
        document: TimeSlotSearchExternalDocument,
        variables,
      }),
    }),
  }),
})

export { injectedRtkApi as api }
